// src/pages/Signup.jsx

import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SignupForm from '../components/Signup/SignupForm';
import TokenService from '../services/tokenService';
import useTheme from '../hooks/useTheme';

const Signup = () => {
  const { i18n } = useTranslation();
  const history = useHistory();
  
  // Apply theme
  useTheme();

  useEffect(() => {
    // Redirect if already authenticated
    const token = TokenService.getAuthToken();
    if (token) {
      history.push('/home');
    }
  }, [history]);

  const handleCancel = () => {
    // Navigate back to signin with current language
    history.push(`/?lang=${i18n.language}`);
  };

  return (
    <SignupForm onCancel={handleCancel} />
  );
};

export default Signup;